import React, { useEffect, useRef, useState, useCallback } from "react";
import { message } from "antd";
import Hexapi from "../../utility/HexAPI/Hexapi";
import trackleadslogo from "../../assets/trackleadslogo.png";
import "./InvitationPage.css";
import { decodeUrl } from "../customerenquiry/decodeUrl";
import heximg from "../../assets/trackhrlogo.png";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const GIS_SCRIPT_SRC = "https://accounts.google.com/gsi/client";

function decodeJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join(""),
    );
    return JSON.parse(jsonPayload);
  } catch (err) {
    console.error("Failed to decode JWT:", err);
    return null;
  }
}

function loadGoogleScript() {
  return new Promise((resolve, reject) => {
    if (window.google?.accounts?.id) {
      resolve();
      return;
    }
    const existing = document.querySelector(`script[src="${GIS_SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.src = GIS_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

const BrandPanel = () => (
  <div className="tl-panel-left">
    <div className="tl-orb tl-orb-1" />
    <div className="tl-orb tl-orb-2" />
    <div className="tl-panel-grid" />

    <div className="tl-logo-wrap">
      <img src={trackleadslogo} alt="TrackLeads Logo" />
    </div>

    <div className="tl-panel-copy">
      <div className="tl-panel-eyebrow">
        <span className="tl-panel-eyebrow-dot" />
        Team Workspace
      </div>
      <h1 className="tl-panel-title">
        Where every lead gets{" "}
        <span className="tl-panel-title-accent">tracked to close.</span>
      </h1>
      <p className="tl-panel-sub">
        Accept your invitation to start routing, tracking, and closing deals with your team in real time.
      </p>
    </div>

    <div className="tl-partner-footer">
      <span className="tl-partner-label">Developed and marketed by</span>
      <div className="tl-partner-row">
        <img alt="Hex Business Innovations" src={heximg} />
        <span className="tl-partner-name">Hex Business Innovations</span>
      </div>
    </div>
  </div>
);

const InvitationPage = () => {
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);
  const [inviteData, setInviteData] = useState(null);
  const [status, setStatus] = useState(null);
  const [urlDetails, setUrlDetails] = useState(null);
  const [isResolved, setIsResolved] = useState(false);
  const [checkingGoogle, setCheckingGoogle] = useState(false);
  const [googleUserInfo, setGoogleUserInfo] = useState(null); 
  const [googleCredential, setGoogleCredential] = useState(null); 
  const [googleError, setGoogleError] = useState(null);
  const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  const [checkingEmail, setCheckingEmail] = useState(false);

  const promptTriggered = useRef(false);

  useEffect(() => {
    decodeUrl(window.location.href).then((res) => {
      let parsedDetails = null;
      try {
        parsedDetails = res?.invitationdetails
          ? typeof res.invitationdetails === "string"
            ? JSON.parse(res.invitationdetails)
            : res.invitationdetails
          : null;
      } catch (e) {
        console.error("Failed to parse invitation details", e);
      }
      setUrlDetails(parsedDetails);
      setIsResolved(true);
    });
  }, []);

const db="CRM_Dbase_Master"
const sp="trackhr.co.in"
const ps= "123@@HexDev"
const ur ="AlishaHex"

  const checkAgentLoginExists = async (username) => {
console.log(username,"username")
console.log("calledddd")
    const obj = {
      query: `[dbo].[CRM_Proc_Check_Email_Exists] @username='{0}'`,
      queryArr: [`${username}`],
      dbname: db,
			serverip: sp,
			username: ur,
			password: ps,
    };
console.log(obj,"obj")
try {
   const data = await Hexapi(obj);
console.log(data,"data")
    const result = data?.[""]?.[0];
    return { exists: result?.command == 1, msg: result?.msg };
} catch (error) {
   return { exists: 0, msg: "" };
}
   
  };

 

  const handleAcceptClick = () => {
    if (  checkingEmail || actionLoading) return;
console.log("callecccccccccccc")
    if (alreadyRegistered) {
      message.error("This account is already registered. Please login instead.");
     
      return;
    }

    handleAccept(googleUserInfo);
  };

 
  const handleAccept = async (userInfo) => {
console.log()
    if (!urlDetails) {
      message.error("Invalid invitation link.");
      return;
    }
console.log(urlDetails,"urlDetails")
    setActionLoading("accept");
    try {
      const logininfo = {
        dbname: urlDetails.orgdbName,
        serverip: urlDetails.serverip,
        dbusername: urlDetails.dbusername,
        dbpassword: urlDetails.dbpassword,
      };

      const { exists } = await checkAgentLoginExists(urlDetails.email);
console.log(exists,"exists")
      if (exists) {
        message.error("This account is already registered. Please login instead.");
     
        return;
      }
const newobj = {
				query: `[dbo].[CRM_Proc_Agent_Register] @username ='{0}', @dbid='{1}'`,
				queryArr: [`${urlDetails?.email}`, `${urlDetails?.dbid}`],
				dbname: "CRM_Dbase_Master",
				serverip: "trackhr.co.in",
				username: "AlishaHex",
				password: "123@@HexDev",
			};
			const newStepResp = await Hexapi(newobj);
console.log(newStepResp,"newStepResp")
if (newStepResp?.[""]?.[0]?.command != 1) {
    message.error(newStepResp?.[""]?.[0]?.msg);
    return;
}
      const obj = {
        query: `[CRM_Proc_User_Register_Submit] @username='{0}',@password='{1}',@orgname='{2}'`,
        queryArr: [`${urlDetails?.email}`, "", `${urlDetails?.orgname}`],
        dbname: logininfo.dbname,
        serverip: logininfo.serverip,
        username: logininfo.dbusername,
        password: logininfo.dbpassword,
      };
console.log(obj,"obj")
      const resp = await Hexapi(obj);

      if (resp?.[""]?.[0]?.command == 1) {
        setStatus("accepted");
      } else {
        message.error(resp?.[""]?.[0]?.msg || "Failed to accept invitation.");
      }
    } catch (err) {
      console.error(err);
      console.error("handleAccept error:", err);
  message.error("Debug: " + err.message);
    } finally {
      setActionLoading(null);
    }
  };

  const handleReject = async () => {
    setActionLoading("reject");
    // try {
    //   const obj = {
    //     query: `[dbo].[CRM_Proc_Agent_RejectInvite] @AgentID='{0}'`,
    //     queryArr: [`${urlDetails.agentid}`],
    //     dbpassword: urlDetails?.dbpassword,
    //     dbusername: urlDetails?.dbusername,
    //     orgdbName: urlDetails?.orgdbName,
    //     serverip: urlDetails?.serverip
    //   };
    //   const res = await Hexapi(obj);
    //   setStatus(res?.[""]?.[0]?.command === 1 ? "rejected" : "invalid");
    // } catch {
    //   setStatus("invalid");
    // } finally {
    //   setActionLoading(null);
    // }
  };

  if (loading) {
    return (
      <div className="tl-invite-root">
        <BrandPanel />
        <div className="tl-panel-right">
          <div className="tl-loader-wrap">
            <div className="tl-loader-ring" />
          </div>
        </div>
      </div>
    );
  }

  if (status === "accepted") {
    return (
      <div className="tl-standalone">
        <div className="tl-card-glow-wrapper tl-fade-item">
          <div className="tl-card" style={{ textAlign: "center" }}>
            <div className="tl-status-icon is-success tl-fade-item tl-d1">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path d="M5 13l4 4L19 7" stroke="#16A34A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h2 className="tl-headline tl-fade-item tl-d2">Welcome Aboard!</h2>
            <p className="tl-subtext tl-fade-item tl-d2 mt-2">Your account has been activated successfully.</p>
            <button
              className="tl-btn tl-btn-accept tl-fade-item tl-d3"
              style={{ width: "100%" }}
              onClick={() => (window.location.href = "/login")}
            >
              Continue to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (status === "rejected") {
    return (
      <div className="tl-standalone">
        <div className="tl-card-glow-wrapper tl-fade-item">
          <div className="tl-card" style={{ textAlign: "center" }}>
            <div className="tl-status-icon is-neutral tl-fade-item tl-d1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6 6l12 12M18 6L6 18" stroke="#64748B" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <h2 className="tl-headline tl-fade-item tl-d2">Invite Declined</h2>
            <p className="tl-subtext tl-fade-item tl-d2">You have declined this workspace invitation.</p>
          </div>
        </div>
      </div>
    );
  }

  const email = inviteData?.agentemailaddress || urlDetails?.email || "";
  const initial = email.charAt(0).toUpperCase() || "?";
  const invitedBy = inviteData?.invitedbyname;
  const role = inviteData?.usertype;
  const isBusy = checkingGoogle || checkingEmail || actionLoading !== null;

  return (
    <div className="tl-invite-root">
      <BrandPanel />

      <div className="tl-panel-right">
        <div className="tl-card-glow-wrapper tl-fade-item">
          <div className="tl-card">
            <div className="tl-node-wrap tl-fade-item tl-d1">
              <span className="tl-node-ring" />
              <span className="tl-node-ring tl-ring-2" />
              <div className="tl-node-core">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="8" r="3.2" className="tl-node-icon-stroke" strokeWidth="2" />
                  <path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" className="tl-node-icon-stroke" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
            </div>

            <h2 className="tl-headline tl-fade-item tl-d2">You're Invited</h2>
            <p className="tl-subtext tl-fade-item tl-d2">
              {invitedBy ? `${invitedBy} invited you to collaborate on TrackLeads.` : "Join your team's workspace on TrackLeads."}
            </p>

            <div className="tl-invited-row tl-fade-item tl-d3">
              <div className="tl-avatar">{initial}</div>
              <div className="tl-invited-text">
                <p className="tl-invited-label">Invited Email Address</p>
                <p className="tl-invited-value">{email}</p>
              </div>
            </div>

            {role ? (
              <div className="tl-role-badge tl-fade-item tl-d3">
                <span className="tl-role-dot" />
                {role}
              </div>
            ) : (
              <div style={{ marginBottom: 28 }} />
            )}

            {alreadyRegistered && !checkingEmail && (
              <p className="tl-fineprint" style={{ color: "#DC2626" }}>
                This account is already registered — click Accept to go to login.
              </p>
            )}
            {googleError && !alreadyRegistered && !checkingGoogle && (
              <p className="tl-fineprint" style={{ color: "#DC2626" }}>
                {googleError}
              </p>
            )}

            <div className="tl-actions tl-fade-item tl-d4">
              <button
                className="tl-btn tl-btn-reject"
                onClick={handleReject}
                disabled={actionLoading !== null}
              >
                {actionLoading === "reject" ? <span className="tl-spin" /> : "Decline"}
              </button>

              <button
                className="tl-btn tl-btn-accept"
                onClick={handleAcceptClick}
                disabled={isBusy}
              >
                {isBusy ? <span className="tl-spin" /> : "Accept Invite"}
              </button>
            </div>

            <p className="tl-fineprint tl-fade-item tl-d5">
              By accepting, you agree to join this workspace in accordance with TrackLeads terms.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvitationPage;